/**
 * 路由配置
 */

export const ROUTE_CONFIG = {
  RESOURCE: '/resource',
  LOGS: '/logs',
  SERVICE_DISCOVERY: '/service-discovery',
  // AI 配置管理 - 各实体类型独立页面
  AI_CONFIG_COMPONENT: '/ai-config/component',
  AI_CONFIG_DATASET: '/ai-config/dataset',
  AI_CONFIG_THINKING_MODE: '/ai-config/thinking-mode',
  AI_CONFIG_RESPONSE_FORMAT: '/ai-config/response-format',
  // 统一管理页面
  UNIFIED_MANAGEMENT: '/unified-management',
  // 兼容旧路由
  AI_CONFIG: '/ai-config',
};

export const MENU_ROUTE_CONFIG = [
  {
    key: 'resource',
    label: 'AI 资源管理',
    path: ROUTE_CONFIG.RESOURCE,
    icon: 'DatabaseOutlined',
  },
  {
    key: 'unified-management',
    label: '统一管理',
    path: ROUTE_CONFIG.UNIFIED_MANAGEMENT,
    icon: 'AppstoreOutlined',
  },
  {
    key: 'service-discovery',
    label: '微服务发现',
    path: ROUTE_CONFIG.SERVICE_DISCOVERY,
    icon: 'AppstoreOutlined',
  },
  {
    key: 'ai-config-component',
    label: '应用组件管理',
    path: ROUTE_CONFIG.AI_CONFIG_COMPONENT,
    icon: 'AppstoreOutlined',
  },
  {
    key: 'ai-config-dataset',
    label: '应用数据集管理',
    path: ROUTE_CONFIG.AI_CONFIG_DATASET,
    icon: 'DatabaseOutlined',
  },
  {
    key: 'ai-config-thinking-mode',
    label: '思考方式管理',
    path: ROUTE_CONFIG.AI_CONFIG_THINKING_MODE,
    icon: 'ThunderboltOutlined',
  },
  {
    key: 'ai-config-response-format',
    label: '返回格式管理',
    path: ROUTE_CONFIG.AI_CONFIG_RESPONSE_FORMAT,
    icon: 'FileTextOutlined',
  },
  {
    key: 'logs',
    label: '调用日志',
    path: ROUTE_CONFIG.LOGS,
    icon: 'FileTextOutlined',
  },

];
